import useLgas from "hooks/useLgas";
import useStates from "hooks/useStates";
import { ChangeEvent, FormEvent } from "react";
import { CreateEmployerJob } from "types/employer.interface";

interface Props {
  onNext: () => void;
  input: CreateEmployerJob;
  onBack: () => void;
  onChange: (
    e:
      | ChangeEvent<HTMLInputElement>
      | ChangeEvent<HTMLSelectElement>
      | ChangeEvent<HTMLTextAreaElement>
      | {
          target: {
            name: string;
            value: string | number;
          };
        }
  ) => void;
  onChangeByNameValue: (name: keyof CreateEmployerJob, value: any) => void;
}

export default function JobLocationForm({
  onNext,
  input,
  onChange,
  onChangeByNameValue,
  onBack,
}: Props) {
  const states = useStates();
  const lgas = useLgas(input.state ?? input.location);

  const submitHandler = async (e: FormEvent) => {
    e.preventDefault();
    onNext();
  };

  return (
    <div className="w-full ">
      <form onSubmit={submitHandler} className=" flex flex-col gap-8 ">
        <div className="flex flex-col gap-1">
          <h2 className=" font-body font-medium text-lg lg:text-xl leading-5 text-body">
            Where would they work?
          </h2>
        </div>

        <div className=" flex items-center gap-4 w-full">
          <div className="flex flex-col gap-2 w-1/2">
            <label htmlFor="state">State of work</label>

            <select
              className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
              name="state"
              onChange={onChange}
              value={input.state}
              defaultValue={input.location}
              required
            >
              <option value="">Select</option>
              {states?.map((category: any) => (
                <option key={category.label} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-2 w-1/2">
            <label htmlFor="lga">LGA of work</label>
            <select
              className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
              name="lga"
              defaultValue={input.area}
              onChange={onChange}
              value={input.lga}
              required
            >
              <option value="">Select</option>
              {lgas?.map((category) => (
                <option key={category.label} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <label htmlFor="area">Specific Area / Neighborhood</label>
          <input
            placeholder="Area"
            id="area"
            name="area"
            value={input.area}
            onChange={onChange}
            required
            className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex items-center gap-4 mt-8">
          <button onClick={onBack} className=" px-10">
            Back
          </button>
          <button className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition-colors">
            Next
          </button>
        </div>
      </form>
    </div>
  );
}
